import { MeetingActionsModalComponent } from './../meeting-actions-modal/meeting-actions-modal.component';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Meeting } from 'src/app/interfaces/meeting.interface';
import { ModalSizes, MotifModal } from '@ey-xd/ng-motif';
import { MeetingDetailsModalComponent } from '../meeting-details-modal/meeting-details-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-meeting-card',
  templateUrl: './meeting-card.component.html',
  styleUrls: ['./meeting-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeetingCardComponent implements OnInit {
  @Input() meeting!: Meeting;
  @Input() type: string = 'past';
  readonly modalSizes = ModalSizes;
  constructor(public modal: MotifModal) {}
  private eventsSubscription: Subscription | undefined;
  @Output() openDetailsModalParent = new EventEmitter<string>();

  ngOnInit(): void {
    // console.log(this.meeting);
  }
  openActionsModal(){
    const modalRef = this.modal.open(MeetingActionsModalComponent, {
      size: ModalSizes.SM
    });
    modalRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  openDetailsModal(){
    this.openDetailsModalParent.next('meeting');
  }
}
